import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import React from "react";
import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { useFormContext } from "react-hook-form";
import { useEquipment, useUser } from "@services/servicesGenericsTables";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";

const PreparationDP = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const filteredProcedures = useFilteredProcedures("PRE");

  const { currentPreparation } = useAnalysis();

  return (
    <>
      {currentPreparation.index !== undefined && (
        <ResponsiveFormContainer columns={5}>
          <MAutocomplete
            key={JSON.stringify(form.getValues("analysis_analyst"))}
            name="analysis_analyst"
            options={userList}
            label="Seleccione un analista"
            getOptionLabel={(option) => option.username || ""}
            validation={{ required: "El analista es requerido" }}
            disabled={!currentPreparation.canEdit}
          />

          <MAutocomplete
            key={JSON.stringify(form.getValues("preparation_procedure"))}
            name="preparation_procedure"
            options={filteredProcedures}
            label="Procedimiento MLPMA"
            getOptionLabel={(option) => `${option.numop}` || ""}
            //validation={{ required: "El procedimiento es requerido" }}
            disabled={!currentPreparation.canEdit}
          />
          <MDatePicker
            name="start_date"
            pickerType="date"
            label="Fecha de inicio"
            validation={{
              required: "La fecha es requerida",
            }}
            disabled={!currentPreparation.canEdit}
          />

          <MAutocomplete
            key={JSON.stringify(form.getValues("analysis_equipment"))}
            name="analysis_equipment"
            options={equipmentList}
            label="Seleccione Equipos/Geometrías"
            getOptionLabel={(option) =>
              `${option.codigo} - ${option.descripcion}` || ""
            }
            validation={{ required: "El Equipos/Geometrías es requerido" }}
            multiple={true}
            disabled={!currentPreparation.canEdit}
          />

          <MTextField
            key={JSON.stringify(form.getValues("analysis_amount_sample"))}
            name="analysis_amount_sample"
            placeholder="Cantidad de muestra"
            label="Cantidad de muestra"
            type="number"
            validation={{ required: "La cantidad de muestra es requerida" }}
            fullWidth
            disabled={!currentPreparation.canEdit}
          />
        </ResponsiveFormContainer>
      )}
    </>
  );
};

export default PreparationDP;
